export default "__VITE_ASSET__BAICwJ0g__"